<template>
    <div :id="modalId" uk-modal>
        <div class="uk-modal-dialog uk-modal-body business-unit-form">
            <h2 class="uk-modal-title">Add Business Unit</h2>
            <form ref="form" class="">
                <div class="uk-grid">
                    <div class="uk-width-2-3 uk-form-controls js-upload" uk-form-custom>
                        <label>
                            <input type="file" name="logo" class="uk-input" v-on:change="imageChanged" />
                            <img v-if="logoPath && !imageSelected" :src="logoPath + '/0/65'" />
                            <div v-if="!logoPath && !imageSelected" class="image-upload">
                                <i class="fas fa-plus-circle"></i> Upload Image
                            </div>
                            <div v-if="imageSelected" class="image-upload">
                                <i class="fas fa-exclamation-triangle"></i> Image Ready
                            </div>
                        </label>
                    </div>
                    <div class="uk-width-1-4 uk-form-controls">
                        <label for="bu_status" class="uk-form-label">Status</label>
                        <select id="bu_status" name="status" v-model="status" class="uk-select" :class="{active:isActive, inactive:!isActive}">
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>
                <div class="uk-grid">
                    <div class="uk-width-2-3 uk-form-controls">
                        <label for="bu_name" class="uk-form-label">Unit Name</label>
                        <input id="bu_name" name="name" type="text" class="uk-input" v-model="name" />
                    </div>
					<div class="uk-width-2-3 uk-form-controls">
                        <label for="bu_prefix" class="uk-form-label">Project Prefix</label>
                        <input id="bu_prefix" name="project_prefix" type="text" class="uk-input" v-model="project_prefix" />
                    </div>
                    <!--div class="uk-width-1-3 uk-form-controls">
                        <label class="uk-form-label">Manager</label>
                        <select name="manager_id" v-model="managerId" class="uk-select">
                            <option value="0">SELECT MANAGER</option>
                            <option v-for="(name, code) in managers" :value="code">{{ name }}</option>
                        </select>
                    </div-->
                </div>
				<div class="uk-grid">
					<div class="uk-width-1-2">
						<label class="uk-form-label">Manager(s)</label>
						<select v-model="managerId" class="uk-select">
							<option value="0">SELECT MANAGER</option>
							<option v-for="(name, code) in managers" :value="code">{{ name }}</option>
						</select>
					</div>
					<div class="uk-width-1-2 tag-cloud">
                        <span class="tag" v-for="manId in managerIds">
                            {{ managers[manId] }}
                            <i class="fas fa-times" @click="dropManager(manId)"></i>
                        </span>
					</div>
				</div>
                <div class="uk-grid">
                    <div class="uk-width-1-2">
                        <label class="uk-form-label">Recruiter(s)</label>
                        <select v-model="recruiterId" class="uk-select">
                            <option value="0">SELECT RECRUITER</option>
                            <option v-for="(name, code) in recruiters" :value="code">{{ name }}</option>
                        </select>
                    </div>
                    <div class="uk-width-1-2 tag-cloud">
                        <span class="tag" v-for="recId in recruiterIds">
                            {{ recruiters[recId] }}
                            <i class="fas fa-times" @click="dropRecruiter(recId)"></i>
                        </span>
                    </div>
                </div>
				<div class="uk-grid">
                    <div class="uk-width-1-2">
                        <label class="uk-form-label">Send Notifications</label>
                        <select v-model="adminId" class="uk-select">
                            <option value="0">SELECT ADMIN</option>
                            <option v-for="(name, code) in admins" :value="code">{{ name }}</option>
                        </select>
                    </div>
                    <div class="uk-width-1-2 tag-cloud">
                        <span class="tag" v-for="admId in adminIds">
                            {{ admins[admId] }}
                            <i class="fas fa-times" @click="dropAdmin(admId)"></i>
                        </span>
                    </div>
                </div>
                <div class="uk-grid uk-margin-small-top">
                    <div class="uk-width-1-2">
                        <div>
                            <label for="bu_address1" class="uk-form-label">Address 1</label>
                            <div class="uk-form-controls">
                                <input id="bu_address1" type="text" name="address1" v-model="location.address1" class="uk-input ">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-2">
                        <div>
                            <label for="bu_address2" class="uk-form-label">Address 2</label>
                            <div class="uk-form-controls">
                                <input id="bu_address2" type="text" name="address2" v-model="location.address2" class="uk-input ">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="uk-grid uk-margin-small-top">
                    <div class="uk-width-1-3">
                        <div>
                            <label for="bu_city" class="uk-form-label">City</label>
                            <div class="uk-form-controls">
                                <input id="bu_city" type="text" name="city" v-model="location.city" class="uk-input ">
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3">
                        <div>
                            <label for="bu_state" class="uk-form-label">State</label>
                            <div class="uk-form-controls">
                                <select id="bu_state" name="state" class="uk-select " v-model="location.state">
                                    <option value="">-- Select State --</option>
                                    <option v-for="(name, code) in states" :value="code">{{ name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-1-3">
                        <div>
                            <label for="bu_postal" class="uk-form-label">Zip Code</label>
                            <div class="uk-form-controls">
                                <input id="bu_postal" type="text" name="postal" v-model="location.postal" class="uk-input ">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="divider uk-margin"></div>
            <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitForm()">Finish</button>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Cancel</button>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            modalId:String,
            post:String,
            table:{
                type: String,
                default: null
            },
            get:String
        },

        data(){
            return {
                id:null,
                logoPath:null,
                uploadPath:"",
                imageSelected: false,
                status:"active",
                name:"",
                project_prefix:"",
                managerId:0,
                managers:{},
                recruiterId:0,
                recruiterIds:[],
                managerIds:[],
                recruiters:{},
				admins:{},
				adminId:0,
				adminIds:[],
                states:{},
                location: {
                    address1:"",
                    address2:"",
                    city:"",
                    state:"",
                    postal:""
                }

            }
        },

        mounted() {
            axios.get("/api/forms/states").then(
                (pack) => this.updateStateList(pack)
            );
            axios.get("/api/users/managers").then(
                (pack) => this.updateManagersList(pack)
            );
            axios.get("/api/users/recruiters").then(
                (pack) => this.updateRecruitersList(pack)
            );
            axios.get("/api/users/admins").then(
                (pack) => this.updateAdminsList(pack)
            );
            //make call to get employee dropdown list
        },

        methods: {
            submitForm() {
                let data = new FormData(this.$refs.form);
                let uri = this.post;
                if(this.id !== null){
                    uri = this.ensureEndingSlash(uri) + this.id.toString();
                }
				data.append("manager_ids", this.managerIds);
				data.append("recruiter_ids", this.recruiterIds);
				data.append("admin_ids", this.adminIds);
                axios.post(uri, data)
                    .then(() => this.updateForm(),() => this.updateForm());
            },
            cancel() {
                this.clearForm();
            },
            updateForm(){
                this.clearForm();
                if(this.table){
                    this.$root.$refs[this.table].startSearch();
                }
            },
            clearForm(){
                if(this.id){
                    this.id = null;
                    this.$refs.form.reset();
                    this.status = "active";
                    this.logoPath = null;
                    this.name="";
                    this.project_prefix="";
                    this.managerId=0;
                    this.recruiterIds=[];
                    this.adminIds=[];
                    this.location= {
                        address1:"",
                            address2:"",
                            city:"",
                            state:"",
                            postal:""
                    };
                    this.imageSelected = false;
                }
            },
            loadForm(id){
                this.id = id;
                axios.get(this.ensureEndingSlash(this.get) + id).then((pack) => this.updateFormData(pack));
            },
            updateFormData(pack){
                let data = pack.data.data;

                this.name = data.name;
                this.project_prefix = data.project_prefix;
                this.location = data.location;
                this.status = data.status;

                this.logoPath = data.logo? data.logo.url:"";
                this.imageSelected = false;
				this.managerIds = [];
				for(let i = 0; i < data.managers.length;++i){
					this.managerIds.push(data.managers[i].id);
				}
                this.recruiterIds = [];
                for(let i = 0; i < data.recruiters.length;++i){
                    this.recruiterIds.push(data.recruiters[i].id);
                }
                this.adminIds = [];
                for(let i = 0; i < data.admins.length;++i){
                    this.adminIds.push(data.admins[i].id);
                }
            },
            ensureEndingSlash(str){
                let lastChar = str.substr(str.length - 1);
                if(lastChar != "/"){
                    return str + "/";
                }
                return str;
            },
            updateStateList(pack) {
                if(pack.data.success){
                    this.states = pack.data.data;
                }
            },
            updateManagersList(pack) {
                if(pack.data.success){
                    this.managers = {};
                    for(let i = 0; i < pack.data.data.length;++i){
                        let mgr = pack.data.data[i];
                        this.managers[mgr.id] = mgr.full_name;
                    }
                }
            },
            updateRecruitersList(pack) {
                if(pack.data.success){
                    this.recruiters = {};
                    for(let i = 0; i < pack.data.data.length;++i){
                        let rec = pack.data.data[i];
                        this.recruiters[rec.id] = rec.full_name;
                    }
                }
            },
            updateAdminsList(pack) {
                if(pack.data.success){
                    this.admins = {};
                    for(let i = 0; i < pack.data.data.length;++i){
                        let admin = pack.data.data[i];
                        this.admins[admin.id] = admin.full_name;
                    }
                }
            },
            imageChanged(e){
                if(e.target.files.length > 0){
                    this.imageSelected = true;
                }
            },
            dropRecruiter(id){
                for(let i = 0; i < this.recruiterIds.length;++i){
                    if(this.recruiterIds[i] == id){
                        this.recruiterIds.splice(i, 1);
                        return;
                    }
                }
            },
            dropManager(id){
                for(let i = 0; i < this.managerIds.length;++i){
                    if(this.managerIds[i] == id){
                        this.managerIds.splice(i, 1);
                        return;
                    }
                }
            },
            dropAdmin(id){
                for(let i = 0; i < this.adminIds.length;++i){
                    if(this.adminIds[i] == id){
                        this.adminIds.splice(i, 1);
                        return;
                    }
                }
            }
        },

        computed:{
            isActive(){
                return this.status == "active";
            }
        },
        watch:{
            recruiterId(){
                if(this.recruiterId !== 0){
                    if(this.recruiterIds.indexOf(Number(this.recruiterId)) < 0){
                        this.recruiterIds.push(Number(this.recruiterId));
                    }
                }

                this.recruiterId = 0;
            },
			managerId(){
				if(this.managerId !== 0){
					if(this.managerIds.indexOf(Number(this.managerId)) < 0){
						this.managerIds.push(Number(this.managerId));
					}
				}

				this.managerId = 0;
			},
			adminId(){
				if(this.adminId !== 0){
					if(this.adminIds.indexOf(Number(this.adminId)) < 0){
						this.adminIds.push(Number(this.adminId));
					}
				}

				this.adminId = 0;
			}
        }

    }
</script>
